export { default } from './ExtraItems'



// WEBPACK FOOTER //
// ./src/App/components/ExtraItems/index.js